export default String.raw`
.comparison {
    width: 100%;

    &__wrapper {
        padding: 0 32px;
    }

    &__header {
        padding: 0 12px 20px 0;
    }

    .swiper {
        overflow: hidden !important;
    }

    .top-info .table__row {
        display: flex;
    }

    .top-info .comparer__table-attribute-name,
    .gradient,
    .full-row__empty {
        display: none !important;
    }

    .table {
        &__row {
            display: block;

            &-cell {
                flex: 1 0 33.33%;
            }
        }
    }
}

.comparer {
    &__table-attribute-name {
        align-items: center;
        font-weight: 500;
        border-right: 0;
    }

    &__sticky-header {
        padding: 0 32px;
    }

    &__slider-button-prev,
    &__slider-button-next {
        display: none;
    }
}

//Exception:

.button[aria-label="notify-about-availability"] .button__text {
    max-width: unset;
}
`